import "./hero-image-block.scss";